<template>
  <div>
    <div id="Div9" runat="server">
      <TSZ_Login
        :isDebugMode="$store.getters['TSZ/isDebugMode']"
        class="absolute-center"
        style="max-width: 450px; min-width: 350px; width: 450px"
        @login="login"
      />
    </div>
  </div>
</template>
<script>
import { Cookies } from 'quasar';

import TSZ_Login from '@/shared/login/components/TheLogin.vue';

import '@/components/Usuarios/assets/css/css_usuario_vue.css';
import { QTabs, QRouteTab, QToolbar } from 'quasar';

export default {
  data: function () {
    return {};
  },
  components: {
    TSZ_Login,
    QTabs,
    QRouteTab,
    QToolbar
  },
  methods: {
    login (data) {
      data = data.data;
      this.$store.commit('TSZ/setUser', data.user);
      this.$router.push('/Presupuestos');
      this.$router.go();
    }
  }
};
</script>
